var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home col-md-10 ml-sm-auto col-lg-10 px-4 view-content"},[_c('h3',[_vm._v("Welcome Thailand Post CMS")])])}]

export { render, staticRenderFns }